/* eslint no-console:0 */
const Utils = require('../Utils');

// Browsers provide different visual display for different log levels.
const CONSOLE_OUTPUT = {
  fatal: 'error',
  error: 'error',
  warn: 'warn',
  info: 'info',
  debug: 'log',
};

class ConsoleLogDestination {
  /**
   * Create a new ConsoleLog destination.
   *
   * @param {function} [filter] a function that determines whether or not to
   *                      log specific log events.
   * @param {function} [formatter] a function that determines how the log event
   *                      is converted into a string.
   * @constructor
   */
  constructor(filter = () => true, formatter = Utils.defaultFormatter) {
    this.filter = filter;
    this.formatter = formatter;
  }

  onLog(component, level, data, time) {
    if (this.filter(time, component, level, data)) {
      output(level, this.formatter(time, component, level), data);
    }
  }
}

function output(level, prefix, data) {
  console[CONSOLE_OUTPUT[level]].call(console, prefix, ...data);
}

module.exports = ConsoleLogDestination;
